import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { UserService } from '@pingum/api-services';
import ApiKeyCard from './ApiKeyCard';
import { getTenantFromUrl } from '../../../utils/urlHelper';
import ApiDocumentationCard from './ApiDocumentationCard';
import EntityIdSearchCard from './EntityIDSearchCard';
import { isUserDeveloper } from '../../../utils/tenantAuthenticationHelper';
import Page from '../../widgets/Page';

export class DevelopersComponent extends React.Component {
  render() {
    const roles = UserService.getUserRolesForTenant(
      this.props.profile,
      getTenantFromUrl(),
    );
    return (
      <Page title="Developer APIs">
        {
          isUserDeveloper(roles) && this.props.tenantObject.stripeSubscription !== null
            && (
              <span>
                <ApiKeyCard />
                <ApiDocumentationCard />
                <EntityIdSearchCard />
              </span>
            )
        }
      </Page>
    );
  }
}

DevelopersComponent.propTypes = {
  profile: PropTypes.object,
  tenantObject: PropTypes.object,
};

export const mapStateToProps = (state) => ({
  profile: state.user.user,
  tenantObject: state.tenant.tenant,
});

DevelopersComponent.defaultProps = {
  profile: {},
  tenantObject: { stripeSubscription: null },
};

export default connect(
  mapStateToProps,
  null,
)(DevelopersComponent);
